import { useState } from 'react'
import { FormContainerUserSignUp, FormTitle, Label, StyledInput, InputDiv, FormInfo, Details, FormLink, FormSpan, Flex, Reveal } from '../../../reusable_ui/styles/Forms.styled' 
import { LogoImg } from '../../NavPage/styles/NavPage.styled'
import { LoginFormControl } from './styles/Login.user.styled'
import { InputButton, Check } from '../../../reusable_ui/styles/Button.styled'

const UserLogin = () => {
  const [id, setId] = useState('')
  const [check, setCheck] = useState(true)
  const[password, setPassword] = useState('password')
  const[type, setType] = useState(true)
  const[idx, setIdx] = useState('')
  const[visible, setVisible] = useState(true)

  const CheckState = check ? 'check' : '';
  const CurrentType = type ? 'password' : 'text';
  const Visibility = visible ? '' : 'unreveal'

  const onCheck = () => {
    setId(CheckState)
    setCheck(!check)
  }

  
  const onReveal = () => {
    setPassword(CurrentType)
    setType(!type)
    setIdx(Visibility)
    setVisible(!visible)
  }

  console.log(id)

  return (
    <FormContainerUserSignUp>
       <LogoImg />
      
      <LoginFormControl>
        <FormTitle>
          <span>Sign in</span>
          <p>Sign in to get started with Hydrocis</p>
        </FormTitle>
        <InputDiv>
          <Label>Email address</Label>
          <StyledInput type='email' />
        </InputDiv>
        <InputDiv>
          <Label>Password</Label>
          <StyledInput password type={password} />   
          <Reveal id={idx} onReveal={onReveal} />       
        </InputDiv>
        <Flex><Check onCheck = {onCheck} id = {id} /> <FormSpan>Remember me</FormSpan></Flex> 
        <InputButton login>Sign in</InputButton>
        <FormInfo>
          <Details><FormLink to='/user/reset'>Forgot password?</FormLink></Details>
        </FormInfo>
        <FormInfo>
          <Details>Dont have an account? <FormLink to='/user/sign_up'>Sign Up</FormLink></Details>         
        </FormInfo>
      </LoginFormControl>
    </FormContainerUserSignUp>
  )
}

export default UserLogin